import { combineReducers } from "redux";
import userReducer from "./userSlice";
import allAdminReducer from "./addAdminSlice";

const rootReducer = combineReducers({
  user: userReducer,
  allAdmin: allAdminReducer,
});

export default rootReducer;
